import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RadioType } from '../../../../../../examinationResult.model';

// RadioType and TvBroadcastType are identical unions; RadioType is used here for both.
@Component({
    selector: 'app-broadcaster-type-selector',
    imports: [MatFormField, MatInput, MatLabel, MatRadioModule, TranslatePipe, FormsModule],
    templateUrl: './broadcaster-type-selector.component.html',
})
export class BroadcasterTypeSelectorComponent {
    @Input() type: RadioType | null = null;
    @Output() typeChange = new EventEmitter<RadioType>();
    @Input() station: string | null = null;
    @Output() stationChange = new EventEmitter<string>();
    @Input() stationLabel = '';
    @Input() stationInputId = '';
}
